import { Component, EventEmitter, Input, Output } from '@angular/core';
import { AutoCompleteCompleteEvent, AutoCompleteModule, AutoCompleteSelectEvent } from 'primeng/autocomplete';
import { MedicalService } from '../../../../services/medical.service';
import { FormsModule } from '@angular/forms';
import { DatePipe, NgIf, SlicePipe } from '@angular/common';
import { CardModule } from 'primeng/card';
import { ButtonModule } from 'primeng/button';
import { plainToInstance } from 'class-transformer';
import { Modifier } from '../../../../models/procedure';


@Component({
  selector: 'app-modifier-selector',
  standalone: true,
  imports: [AutoCompleteModule, FormsModule, DatePipe, CardModule, ButtonModule, SlicePipe, NgIf],
  templateUrl: './modifier-selector.component.html',
  styleUrl: './modifier-selector.component.scss'
})
export class ModifierSelectorComponent 
{
  @Input() modifiers? : Modifier[];
  @Output() modifiersChange : EventEmitter<Modifier[]> = new EventEmitter<Modifier[]>();
  @Output() modifierSelected = new EventEmitter<Modifier[]>();

  constructor(private _medicalService:MedicalService)
  {

  }

  modifierSuggestions: Modifier[] = [];

  modifierSearch(event:AutoCompleteCompleteEvent )
  {
    //Update the suggestions to our query results
    this._medicalService.searchModifiers(event.query)
    .then
    (
      modifiers => 
        {
          this.modifierSuggestions = modifiers;
        }
    )
  }

  selectModifier(event: AutoCompleteSelectEvent)
  {
    var modifiers = this.modifiers?.map(m => plainToInstance(Modifier,m));
    this.modifiersChange.emit(modifiers);
    this.modifierSelected.emit(modifiers);
  }

  resetSelection()
  {
    this.modifiers = undefined;
  }

}
